import React from 'react';
import './Hero.scss';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero__glow" aria-hidden="true" />
      <div className="container hero__content">
        <h1 className="hero__title">
          No perseguimos clientes.
          <br />
          <span className="gradient-text">Construimos en lo que creemos.</span>
        </h1>
        <p className="hero__sub">
          Diseñamos y construimos aplicaciones modernas para móvil, web,
          escritorio e IoT — hechas con cuidado, guiadas por valor.
        </p>
      </div>
    </section>
  );
};

export default Hero;
